var SENTRY_RELEASE;SENTRY_RELEASE={name: "HeroSpark", version: "1.24.0"};